import { Layout } from "@/components/layout/Layout";
import { Hero } from "@/components/sections/Hero";
import { Introduction } from "@/components/sections/Introduction";
import { ServicesPreview } from "@/components/sections/ServicesPreview";
import { WhyMe } from "@/components/sections/WhyMe";
import { SubscriptionPlans } from "@/components/sections/SubscriptionPlans";
import { PortfolioPreview } from "@/components/sections/PortfolioPreview";
import { Process } from "@/components/sections/Process";
import { ClientReviews } from "@/components/sections/ClientReviews";
import { CTA } from "@/components/sections/CTA";
import { NewsPreview } from "@/components/sections/NewsPreview";
import { BrandDivider } from "@/components/BrandDivider";
import { StructuredData, webSiteSchema, localBusinessSchema } from "@/components/StructuredData";
import { SEOHead } from "@/components/SEOHead";

const Index = () => {
  return (
    <Layout>
      <SEOHead
        title="Online Sale Specialist | Alles voor je website"
        description="Ik regel alles rondom je website, webshop en online vindbaarheid. Zodat jij je kunt focussen op waar je goed in bent."
        canonical="https://onlinesalespecialist.nl"
      />
      <StructuredData data={[webSiteSchema, localBusinessSchema]} />
      <Hero />
      <Introduction />
      <ServicesPreview />
      <WhyMe />
      <BrandDivider />
      <PortfolioPreview />
      <Process />
      <ClientReviews />
      <NewsPreview />
      <CTA />
    </Layout>
  );
};

export default Index;
